import React, { useState, useEffect } from 'react'
import RenderProfilePicture from '../../../_helpers/profile-picture';

import { Row, Col, Button, Modal, Form } from 'react-bootstrap'

export default function ParticipantConfirmModal({
  show,
  error,
  adding,
  participant,
  shouldNotify,
  isParticipant,
  handleCancel,
  handleConfirm,
}) {
  const [notify, setNotify] = useState(shouldNotify)

  const handleCloseModal = () => {
    setNotify(shouldNotify)
    handleCancel()
  }

  useEffect(() => {
    setNotify(shouldNotify)
  }, [shouldNotify])

  return (
    <>
      {participant &&
        <Modal size='lg' show={show} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title className='font-weight-light'>Confirm Participant</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {error && <div className="alert alert-danger">{error}</div>}

            <Row>
              <Col>Are you sure you want to add <b>{participant.firstName} {participant.lastName}</b> to this conversation?</Col>
            </Row>

            <br />

            <Row>
              <Col xs='1' className='my-auto pr-0'>
                <RenderProfilePicture image={participant.profile} circle cached={false} className='m-auto' />
              </Col>
              <Col className='my-auto'>
                <Row>
                  <Col>
                    {participant.firstName} {participant.lastName}
                  </Col>
                </Row>
                <Row>
                  <Col className='font-weight-light text-muted'>
                    {participant.userType}
                  </Col>
                </Row>
              </Col>
            </Row>

            <br />

            {isParticipant &&
              <>
                <Row className='mb-2 mt-4'>
                  <Col>
                    Would you like to {shouldNotify ? 'continue' : 'start'} receiving notifications for this conversation?
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Check
                      id='notify-switch'
                      type="switch"
                      label="Receive Notifications"
                      checked={notify}
                      onChange={() => setNotify(!notify)}
                      className='text-muted'
                    />
                  </Col>
                </Row>
              </>
            }
          </Modal.Body>
          <Modal.Footer className='border-0'>
            <Button className='w-25' variant="primary" onClick={() => handleConfirm(notify)}>
              {adding ? <i className="fa fa-spinner fa-spin fa-fw"></i> : 'Yes'}
            </Button>
            <Button className='px-4' variant="secondary" onClick={handleCloseModal}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      }
    </>
  );
}
